import { Mail, MapPin, Send } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    // Backend email integration deferred — store locally + show success
    setSent(true);
    toast.success("Merci ! Votre message a été enregistré.");
  };

  return (
    <div data-testid="contact-page">
      <section className="bg-ink text-white py-20 grain relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="eyebrow eyebrow-on-dark"><span className="w-8 h-px bg-gold inline-block align-middle mr-3" />Contact</div>
          <h1 className="font-serif text-5xl lg:text-6xl mt-6 leading-tight tracking-tight">Nous écrire</h1>
        </div>
      </section>
      <section className="py-20 bg-bone">
        <div className="max-w-5xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <h2 className="font-serif text-2xl text-ink">Nous contacter</h2>
            <p className="mt-4 text-foreground/75 leading-relaxed">
              Pour toute demande de presse, partenariat, plaidoyer ou information :
            </p>
            <div className="mt-8 space-y-4 text-sm">
              <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-gold-dark shrink-0 mt-0.5" /> <div>Diaspora · International</div></div>
              <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-gold-dark shrink-0 mt-0.5" /> <a href="mailto:contact@frontunirdc.be" className="hover:text-gold-dark" data-testid="contact-page-email">contact@frontunirdc.be</a></div>
            </div>
          </div>
          <form onSubmit={submit} className="lg:col-span-7 bg-white border border-border rounded-sm p-8 space-y-5" data-testid="contact-form">
            {sent && <div className="bg-ink/5 border-l-2 border-gold p-4 text-sm">Merci, votre message est bien arrivé. Nous reviendrons vers vous sous 48–72h.</div>}
            <div className="grid sm:grid-cols-2 gap-5">
              <Field label="Nom complet" v={form.name} on={(v) => setForm({ ...form, name: v })} test="contact-name" />
              <Field label="Email" type="email" v={form.email} on={(v) => setForm({ ...form, email: v })} test="contact-email" />
            </div>
            <Field label="Sujet" v={form.subject} on={(v) => setForm({ ...form, subject: v })} test="contact-subject" />
            <div>
              <label className="eyebrow text-foreground/70 block mb-2">Message</label>
              <textarea required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                        className="w-full border border-border rounded-sm p-3 min-h-[160px] focus:border-ink outline-none text-sm" data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-primary" data-testid="contact-submit">
              Envoyer <Send className="w-4 h-4" />
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

function Field({ label, v, on, type = "text", test }) {
  return (
    <div>
      <label className="eyebrow text-foreground/70 block mb-2">{label}</label>
      <input required type={type} value={v} onChange={(e) => on(e.target.value)}
             className="w-full border border-border rounded-sm p-3 focus:border-ink outline-none text-sm" data-testid={test} />
    </div>
  );
}
